/** [ROME-8384] Which job date the Overdue date-range filter measures against. */
export const ids = ['jobCreatedAt', 'jobFirstCompletedAt', 'jobCompletedAt'] as const;

/** Rework should not undo an on-time first completion, so this is the default. */
export const defaultId = 'jobFirstCompletedAt';
